export const EMAIL = /^\s*(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@(([\p{Letter}\-0-9]+\.)+[\p{Letter}]{2,})\s*$/u;
